import React from "react";
import copyCodeIcon from "../../../../../../../../../assets/icons/copy_code_blue.svg";
import downloadIcon from "../../../../../../../../../assets/icons/baixar_blue.svg";
import checkIcon from "../../../../../../../../../assets/icons/check.svg";
import { useModal } from "../../../../../../../../../hooks/ModalContext";
import { usePropostas } from "../../../../../../../../../context/PropostasContext";
import { useBoleto } from "../../../../../../../../../context/BoletoContext";
import { useCallback } from "react";
import { RequestAcionamento } from "../../../../../../../../../types/resgitro-acionamento-interface";
import { useDividas } from "../../../../../../../../../context/DividasContext";
import { ModalErro } from "../../../../../../../../Modal/components/erro";
import { useFila } from "../../../../../../../../../context/FilaContext";
import { useClear } from "../../../../../../../../../hooks/useClear";

export const AcordoAccordion = () => {
  const { canalEnvio, selectedContrato, selectedProposta } = usePropostas()
  const { selectedCredor, devedor } = useDividas()
  const { setModal, onClose } = useModal();
  const { boleto, } = useBoleto()
  const { endQueue, devedorFilaSelected, clearSelectedFila } = useFila()
  const { clearData } = useClear()

  // sendAcionamento

  function formatarTelefone(telefone: string) {
    telefone = telefone.replace(/\D/g, '');
    telefone = telefone.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
    return telefone;
  }

  // function verificarPropriedadeIgual(array: Contrato[], propriedade: string) {
  //   return array.every(function (elemento) {
  //     return elemento.hasOwnProperty(propriedade);
  //   });
  // }

  async function finalizarAcordo() {
    // const element = document.getElementById("neg-title");

    // if (verificarPropriedadeIgual(contratos, "tabulado")) {
    //   setModal("Proximo Atendimento", "Atendimento");
    // }

    // if (element) {
    //   limparNegociacoes();
    //   element.scrollIntoView({ behavior: "smooth" });
    //   document.getElementById("acordo")?.removeAttribute("open");
    //   document.getElementById("resumo")?.removeAttribute("open");
    // }
    await endQueue(devedorFilaSelected.id_queue)
    clearSelectedFila()
    clearData()
    onClose()
    setModal("Proximo Atendimento", "Atendimento");
  }

  function baixarBoleto() {
    window.open(boleto?.url, "_blank");
  }

  // async function handleEncerrarAtendimento(observacao: string, dataprev: string) {
  //   const data: RequestRegistroAcionamento = {
  //     app: 'ACIONA_WEB',
  //     codcredor: String(selectedCredor?.credor_crm),
  //     contrato: selectedContrato ? selectedContrato : selectedProposta.contrato,
  //     cpf_cnpj: devedor?.cpf_cnpj,
  //     dataprevisao: dataprev,
  //     idacionamento: '30',
  //     idatendimento: '0',
  //     idcall: '',
  //     idcampanha: '30811',
  //     observacao,
  //     remessa: '',
  //     // telefone: '',
  //     tipo: '',
  //     usuario: '7900'
  //   }




  const copyToClipboard = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.log('Falha ao copiar o texto', err);
    }
  }, []);


  return (
    <details
      id="acordo"
      className={`mb-3 w-full border border-gray-300 bg-white ${!boleto?.url && 'pointer-events-none'}`}
    >
      <summary className="flex w-full cursor-pointer justify-between bg-white px-4 py-3 text-xl font-medium text-gray-800 after:content-['+']">
        Acordo
      </summary>

      {
        boleto && boleto?.url && (
          <div className="px-4 py-2">
            <div className="my-4 flex w-full flex-col items-center justify-center gap-4">
              <h2 className="text-xl font-medium text-green-600">
                Acordo Concluído com Sucesso!
              </h2>
              <div className="mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-green-600">
                <img src={checkIcon} alt="" className="h-14 w-14" />
              </div>
              <div className="w-8/12 bg-green-100 px-8 py-4 text-primary">
                <p className="font-medium">
                  Carta/Acordo enviada para os endereços abaixo:
                </p>
                <div className="flex gap-4 items-center w-full   py-2 text-primary">
                  <strong>{canalEnvio?.canalrecebimento?.toLocaleUpperCase()}: </strong>
                  <p>{canalEnvio.canalrecebimento === 'sms' ? formatarTelefone(canalEnvio?.destinorecebimento || '') : canalEnvio?.destinorecebimento}</p>

                  {/* <strong>WhatsApp: </strong>
              <p>(11)93938-1750</p>

              <strong>SMS: </strong>
              <p>(11)93938-1750</p> */}
                </div>
              </div>

              <div className="my-4 flex w-full items-center justify-center gap-10  ">
                <button className="btn-acordo" onClick={() => baixarBoleto()}>
                  <div className="my-2 flex h-14 w-16 items-center justify-center rounded-md border border-blue-900">
                    <img src={downloadIcon} alt="" />
                  </div>
                  Baixar boleto
                </button>
                <button className="btn-acordo" onClick={() => copyToClipboard(boleto?.url)}>
                  <div className="my-2 flex h-14 w-16 items-center justify-center rounded-md border border-blue-900">
                    <img src={copyCodeIcon} alt="" />
                  </div>
                  Copiar link do boleto
                </button>
                <button className="btn-acordo" onClick={() => copyToClipboard(boleto.dadoboleto[0].linhaDigitavel)}>
                  <div className="my-2 flex h-14 w-16 items-center justify-center rounded-md border border-blue-900">
                    <img src={copyCodeIcon} alt="" />
                  </div>
                  Copiar código
                </button>
              </div>
            </div>
            <div className="mb-8 mt-14 flex w-full items-center justify-center gap-8">
              <button
                className="flex flex-col items-center px-2"
                onClick={() => finalizarAcordo()}
              >
                <div className="btn-finalizado">
                  <img src={checkIcon} alt="" className="my-1 h-8 w-8" />
                  <p>Finalizado</p>
                </div>
                <p className="wrap my-4 h-10 w-[12rem] text-center text-sm text-gray-500">
                  Sem Confirmação de Entrega de Link
                </p>
              </button>
              <button
                className="flex flex-col items-center  px-2"
                onClick={() => finalizarAcordo()}
              >
                <div className="btn-finalizado">
                  <img src={checkIcon} alt="" className="my-1 h-8 w-8" />
                  <p>Finalizado</p>
                </div>
                <p className="wrap my-4 h-10 w-[12rem] text-center text-sm text-gray-500">
                  Com Confirmação de Entrega de Link
                </p>
              </button>
              <button
                className="flex flex-col items-center px-2"
                onClick={() => finalizarAcordo()}
              >
                <div className="btn-finalizado">
                  <img src={checkIcon} alt="" className="my-1 h-8 w-8" />
                  <p>Finalizado</p>
                </div>
                <p className="wrap my-4 h-10 w-[12rem] text-center text-sm text-gray-500">
                  Confirmado Entrega de Link + Autoriz. Pgto
                </p>
              </button>
            </div>
          </div>
        )
      }

      <ModalErro message="ERRO AO GERAR BOLETO!" />
    </details>
  );
};
